<h1 mat-dialog-title class="title-warning">{{ data.header }}</h1>
<mat-dialog-content>{{ data.content }}</mat-dialog-content>
<mat-dialog-actions style="justify-content: end">
  @if (data.showBtnNo) {
    <button mat-dialog-close mat-stroked-button>
      {{ data.titleButtonNo || "No" }}
    </button>
  }
  <button mat-stroked-button cdkFocusInitial (click)="onOk()">
    {{ data.titleButtonOk || "OK" }}
  </button>
</mat-dialog-actions>
